import { AddressParts, Country } from '@wix/locale-dataset-data/typings';
import { getCountryByKey } from '.';

const ADDRESS_PARTS: AddressParts = {
  country: 'country',
  subdivision: 'subdivision',
  addressLine1: 'addressLine1',
  addressLine2: 'addressLine2',
  city: 'city',
  zipCode: 'zipCode',
  firstName: 'firstName',
  lastName: 'lastName',
  company: 'company',
  phone: 'phone',
};

const FORMAT_BY_COUNTRY_DEFAULT = 'USA';

export const getFormattedAddress = (
  addressParts: AddressParts,
  formatCountryKey?: string,
): string => {
  const formatByCounty: Country = formatCountryKey
    ? getCountryByKey(formatCountryKey)
    : getCountryByKey(FORMAT_BY_COUNTRY_DEFAULT);

  const address =
    formatByCounty && formatByCounty.addressPattern
      ? formatByCounty.addressPattern
      : getCountryByKey(FORMAT_BY_COUNTRY_DEFAULT).addressPattern;

  const emptyParts = address
    .split('\n')
    .map((line) =>
      line
        .split(',')
        .map((commaSection) => commaSection.replace(/{{[^}]+}}/g, '')),
    );

  return address
    .split('\n')
    .map((line, lineIndex) => {
      return line
        .split(',')
        .map((lineSection, commaIndex) => {
          if (lineSection === '') {
            return lineSection;
          }
          let replacedLineSection = lineSection;
          Object.keys(ADDRESS_PARTS).forEach((key) => {
            replacedLineSection = replacedLineSection.replace(
              `{{${key}}}`,
              addressParts[key] || '',
            );
          });
          if (emptyParts[lineIndex][commaIndex] === replacedLineSection) {
            return null;
          }
          return replacedLineSection;
        })
        .filter((lineSectionAfterReplace) => lineSectionAfterReplace !== null)
        .join(',');
    })
    .join('\n')
    .replace(/\n+\s*/g, '\n');
};
